import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.el = $(this.element);
    this.tabs = this.el.find('[data-tab]')
    this.showTab(this.tabs[0].dataset.tab)

    this.tabs.on('click', (e) => {
      this.showTab(e.target.dataset.tab)
    })
  }

  showTab(tabName) {
    this.el.find('.tab-content').addClass('hidden');

    this.tabs.each((_, tab) => {
      if (tab.dataset.tab == tabName) {
        tab.classList.toggle("active", true)
        this.el.find(`#${tabName}-tab`).removeClass('hidden').addClass('active')
      } else {
        tab.classList.toggle("active", false)
        this.el.find(`#${tabName}-tab`).removeClass('active')
      }
    })
  }
}